/**
 * Estado da Central de Projetos que o MENU precisa (ADR-0089):
 * - `ativa`: a Central está ligada na unidade (sem isso os itens somem);
 * - `esconder_projetos_executivos`: as 17 telas antigas saem do menu.
 *
 * Lido uma vez por sessão e compartilhado entre os componentes (a tela de
 * configuração chama `recarregarEstadoCentral` depois de salvar). Antes da
 * resposta, vale o padrão seguro: Central desligada e telas antigas visíveis.
 */
import { useEffect, useState } from "react";

import { MODULO_CENTRAL_PROJETOS } from "../config/modulos";
import { useAuth } from "../context/AuthContext";
import { lerEstado } from "../services/centralProjetos";

export const ESTADO_PADRAO = Object.freeze({ ativa: false, esconder_projetos_executivos: false });

let estadoAtual = null;
let carregando = null;
const ouvintes = new Set();

function publicar(estado) {
  estadoAtual = estado;
  ouvintes.forEach((ouvinte) => ouvinte(estado));
}

export async function recarregarEstadoCentral(request) {
  if (typeof request !== "function") return ESTADO_PADRAO;
  try {
    const resposta = await lerEstado(request);
    publicar({ ...ESTADO_PADRAO, ...(resposta || {}) });
  } catch {
    // Sem resposta, fica o padrão seguro (nada novo aparece, nada antigo some).
    publicar(ESTADO_PADRAO);
  }
  return estadoAtual;
}

export default function useEstadoCentral() {
  const { request, authenticated, temModulo } = useAuth() || {};
  // Sem a Central contratada (ADR-0102) a rota responde 404: nem pergunta.
  const contratada = Boolean(temModulo?.(MODULO_CENTRAL_PROJETOS));
  const [estado, setEstado] = useState(estadoAtual || ESTADO_PADRAO);

  useEffect(() => {
    ouvintes.add(setEstado);
    if (authenticated && contratada && !estadoAtual && !carregando) {
      carregando = recarregarEstadoCentral(request).finally(() => {
        carregando = null;
      });
    }
    if (!authenticated) estadoAtual = null;
    return () => {
      ouvintes.delete(setEstado);
    };
    // O request muda de identidade com o token; a leitura é uma por sessão.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, contratada]);

  return contratada ? estado : ESTADO_PADRAO;
}
